// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"e0c93298fc2e45f5abfa","453":"f098ad0e5d8fd11452c4","522":"4e2e01a8fbfa2ae3567b"}[chunkId] + ".js";
};